<template>
    <div>
        <Card>
            <Row :gutter="16">
                <Col span="24">
                    <div class="global-tool-bar">
                        <div class="left-bar">
                            <span class="title">收支汇总表</span>
                            <span style="margin-left:20px;">会员类别:</span>
                            <RadioGroup v-model="userType"
                                        style="margin-left:4px;"
                                        @on-change="onUserTypeChage">
                                <Radio label="F"> <span>外部会员</span></Radio>
                                <Radio label="E"> <span>内部会员</span></Radio>
                            </RadioGroup>
                            <span style="margin-left:20px;">会员账号:</span>
                            <Input v-model="userName"
                                   size="small"
                                   style="margin-left:4px;width: 150px"
                                   placeholder="输入会员账号或名称" />

                            <span style="margin-left:20px;">开始结束时间:</span>
                            <DatePicker type="daterange"
                                        v-model="selectDates"
                                        size="small"
                                        transfer
                                        placement="bottom-end"
                                        placeholder="选择期初和期末时间"
                                        style=" margin-left:4px;width: 200px"></DatePicker>

                            <Button type="primary"
                                    size='small'
                                    class="btns"
                                    shape="circle"
                                    icon="ios-search"
                                    @click="onSearch()">查询</Button>

                            <Button type="info"
                                    size="small"
                                    class="btns"
                                    shape="circle"
                                    icon="ios-send"
                                    @click="onExport()">导出</Button>
                        </div>
                        <div class="right-bar">

                        </div>
                    </div>
                </Col>
            </Row>

            <Row :gutter="16"
                 style="margin-top:10px;">
                <Col span="24">
                    <stand-pagination-table :columns="mainTable.columns"
                                            :data="mainTable.data"
                                            :extHeight="60"
                                            :loading="mainTable.loading"
                                            :table-search="mainTable.tableSearch"
                                            :table-load-event="getMemberTransactionList" />
                </Col>
            </Row>
        </Card>
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { dateTimeRender } from '@/libs/tableRowTimeRender';
import { numberToFixed, number2ThousandsFormat, thousandsFormat2Number, getNumberThousandString } from '@/components/number-input/display-format';
import { getThisMonthStart, getTodayDateString } from '@/libs/logic';
import { getMemberTransactionSum } from '@/api/modules/finance-management/member-transaction';
import { DOWNLOAD_SERVER } from '@/api/modules/files';
import { result } from 'lodash';

export default {
    name: 'member-transaction-sum-list',
    components: {
        StandPaginationTable,
        SearchCard
    },
    data() {
        return {
            userName: '',
            userType: 'F',
            selectDates: [],
            mainTable: {
                columns: [
                    { title: '会员账号', key: 'userName', width: 100, align: 'center', fixed: 'left', excel: true },
                    { title: '会员名称', key: 'userPersonName', width: 140, align: 'center', fixed: 'left', excel: true },
                    {
                        title: '期初余额', key: 'balance', width: 120, align: 'center', excel: true,
                        render: (h, params) => {
                            return h('div', [
                                h('span', {
                                    style: {
                                        color: 'blue'
                                    }
                                }, params.row.balance)
                            ]);
                        }
                    },
                    { title: '通联微信充值', key: 'tlwxcz', width: 120, align: 'center', excel: true },
                    { title: '通联支付宝充值', key: 'tlzfbcz', width: 120, align: 'center', excel: true },
                    { title: '通联银联充值', key: 'tlylcz', width: 120, align: 'center', excel: true },
                    { title: '通联云闪付充值', key: 'tlysfcz', width: 120, align: 'center', excel: true },
                    { title: '招行微信充值', key: 'zhwxcz', width: 120, align: 'center', excel: true },
                    { title: '招行支付宝充值', key: 'zhzfbcz', width: 120, align: 'center', excel: true },
                    { title: '招行银联充值', key: 'zhylcz', width: 120, align: 'center', excel: true },
                    { title: '建行微信充值', key: 'jhwxcz', width: 120, align: 'center', excel: true },
                    { title: '建行支付宝充值', key: 'jhzfbcz', width: 120, align: 'center', excel: true },
                    { title: '建行支付或跨行付', key: 'jhzhfhkhf', width: 120, align: 'center', excel: true },
                    { title: '公司微信6101', key: 'gswx', width: 120, align: 'center', excel: true },
                    { title: '手充(农行13341)', key: 'nh13341', width: 120, align: 'center', excel: true },
                    { title: '手充(昆明收现金)', key: 'kmsxj', width: 120, align: 'center', excel: true },
                    { title: '手充(工行69697)', key: 'gh69697', width: 120, align: 'center', excel: true },
                    { title: '手充(支付宝F)', key: 'zfbzf', width: 120, align: 'center', excel: true },
                    { title: '手充(E管家)', key: 'egj', width: 120, align: 'center', excel: true },
                    { title: '手充(退会员余额)', key: 'thyye', width: 120, align: 'center', excel: true },
                    { title: '手充(调整会员余额)', key: 'tzhyye', width: 120, align: 'center', excel: true },
                    { title: '手充(手工录入其它)', key: 'sglrqt', width: 120, align: 'center', excel: true },
                    { title: '资金库减定金', key: 'zjkjdj', width: 120, align: 'center', excel: true },
                    { title: '资金库减总额', key: 'zjkjze', width: 120, align: 'center', excel: true },
                    { title: '资金库收货款', key: 'zjkshk', width: 120, align: 'center', excel: true },
                    { title: '包装费支付', key: 'bzfzf', width: 120, align: 'center', excel: true },
                    { title: '配送费支付', key: 'psfzf', width: 120, align: 'center', excel: true },
                    { title: '资金库减违约金', key: 'zjkjwyj', width: 120, align: 'center', excel: true },
                    { title: '资金库减专利费', key: 'zjkjzlf', width: 120, align: 'center', excel: true },
                    { title: '资金库收配送费', key: 'zjkspsf', width: 120, align: 'center', excel: true },
                    { title: '资金库收包装费', key: 'zjksbzf', width: 120, align: 'center', excel: true },
                    { title: '资金库收退款金', key: 'zjkstkj', width: 120, align: 'center', excel: true },
                    { title: '资金库退退款金', key: 'zjktkj', width: 120, align: 'center', excel: true },
                    { title: '退纸箱费', key: 'tzxf', width: 120, align: 'center', excel: true },
                    { title: '资金库减退纸箱费', key: 'zjktzxf', width: 120, align: 'center', excel: true },
                    { title: '资金库收违约金', key: 'zjkswyj', width: 120, align: 'center', excel: true },
                    { title: '手动定金转余额', key: 'sddjzye', width: 120, align: 'center', excel: true },
                    { title: '资金库收定金', key: 'zjksdj', width: 120, align: 'center', excel: true },
                    {
                        title: '期末余额', key: 'balance1', width: 120, align: 'center', excel: true,
                        render: (h, params) => {
                            return h('div', [
                                h('span', {
                                    style: {
                                        color: 'blue'
                                    }
                                }, params.row.endbalance)
                            ]);
                        }
                    },
                    {
                        title: '期初定金', key: 'endbalance', width: 120, align: 'center', excel: true,
                        render: (h, params) => {
                            return h('div', [
                                h('span', {
                                    style: {
                                        color: 'red'
                                    }
                                }, params.row.balance1)
                            ]);
                        }
                    },
                    { title: '定金库收定金', key: 'djksdj', width: 120, align: 'center', excel: true },
                    { title: '定金库减定金', key: 'djkjdj', width: 120, align: 'center', excel: true },
                    { title: '手动定金转余额减定金', key: 'sddjzyejdj', width: 120, align: 'center', excel: true },
                    {
                        title: '期末定金', key: 'endbalance1', width: 120, align: 'center', excel: true,
                        render: (h, params) => {
                            return h('div', [
                                h('span', {
                                    style: {
                                        color: 'red'
                                    }
                                }, params.row.endbalance1)
                            ]);
                        }
                    }

                ],
                data: [],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        let beginDate = this.getThisMonthStart();
        let endDate = this.getTodayDateString();
        this.selectDates = [beginDate, endDate];
        this.init();
    },
    methods: {
        getTodayDateString,
        getThisMonthStart,
        number2ThousandsFormat,
        thousandsFormat2Number,
        getNumberThousandString,
        init() {
            this.getMemberTransactionList();
        },
        onSearch() {
            this.getMemberTransactionList();
        },
        onExport() {
            this.mainTable.tableSearch.excelExport.columns = this.mainTable.columns
                .filter(col => col.excel)
                .map(col => {
                    return {
                        key: col.key,
                        title: col.title
                    };
                });

            this.mainTable.loading = true;
            this.mainTable.tableSearch.needExport = 1;
            this.mainTable.tableSearch.userName = this.userName;
            this.mainTable.tableSearch.userType = this.userType;
            if (this.userType) {
                search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "memberType");
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: 'memberType',
                    type: 'eq',
                    value: this.userType
                });
            }
            this.mainTable.tableSearch.beginDate = this.selectDates[0];
            this.mainTable.tableSearch.endDate = this.selectDates[1];
            getMemberTransactionSum(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    if (res.code === 0) {
                        let url = DOWNLOAD_SERVER + res.data.exportFileName;
                        this.$downLoadFile(url);
                        // window.open(FILE_SERVER + res.data.exportFileName, "_blank");
                    }
                }
                this.mainTable.loading = false;
            });
        },
        onUserTypeChage(e){
            this.getMemberTransactionList();
        },
        getMemberTransactionList(reset = false) {
            this.mainTable.loading = true;
            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            this.mainTable.tableSearch.needExport = 0;
            this.mainTable.tableSearch.userName = this.userName;
            this.mainTable.tableSearch.userType = this.userType;
            if (this.userType) {
                search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "memberType");
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: 'memberType',
                    type: 'eq',
                    value: this.userType
                });
            }
            this.mainTable.tableSearch.beginDate = this.selectDates[0];
            this.mainTable.tableSearch.endDate = this.selectDates[1];
            getMemberTransactionSum(this.mainTable.tableSearch).then(res => {
                this.mainTable.loading = false;
                if (res.code === 0) {
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);

                    this.mainTable.data = [];

                    let noSetColums = ["userUuid", "userName", "userPersonName", "userUuid"];
                    res.data.records.forEach(item=>{
                        this.mainTable.data.push(this.setNumberThousandStringForObj(item, noSetColums));
                    });

                    let pageSum= this.sumAttribute(res.data.records, noSetColums);
                    pageSum.userPersonName='本页合计';
                    this.mainTable.data.push(pageSum);
                    let totalSum= this.setNumberThousandStringForObj(res.data.sumInfo[0], noSetColums);
                    totalSum.userPersonName='总合计';
                    this.mainTable.data.push(totalSum);
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }
            });
        },
        setNumberThousandStringForObj(obj, noSetColums){
            let result={};
            for (let key in obj) {
                if(!noSetColums.includes(key)){
                    result[key]=getNumberThousandString(obj[key], 0);
                }
                else{
                    result[key]=obj[key];
                }
            }
            return result;
        },
        sumAttribute(arr, noSetColums){
            let result={};
            for (let key in arr[0]) {
                if (!noSetColums.includes(key)) {
                    let sumResult = arr.reduce((sumData, obj) => {
                        return sumData + (obj[key]?obj[key]:0);
                    }, 0);
                    result[key]=getNumberThousandString(sumResult, 0);
                }
            }
            return result;
        }

    }
};
</script>
<style>
</style>
